
import {
	Vue,
	Component,
	Prop,
	PropSync,
	Watch,
	Inject
} from "vue-property-decorator";
import Header from "@/components/base/table/header/TitleHeader.vue";
import Search from "@/components/semantics/HomeSearch.vue";
import PolicyTable from "@/components/base/table/body/TableTextDecoration.vue";
import ProjectTable from "@/components/base/table/body/TableBoxText.vue";
import ToolTable from "@/components/base/table/body/TableImg.vue";
import PublicyTable from "@/components/base/table/body/TableEl.vue";
import { Loading } from "element-ui";
import { Action, Getter, State } from "vuex-class";
import {
	deepClone,
	removeHTMLTag,
	getParentArea,
	getAreaDepartmentByLastCode
} from "@/common/utils";
import { getBaseInfo } from "@/common/cookie";
import { pageViewUnit } from "@/config";
@Component({
	name: "Home",
	components: {
		Header, // text-header
		Search, // search-bar
		PolicyTable, // text-table
		ProjectTable,
		PublicyTable,
		ToolTable
	}
})
export default class Home extends Vue {
	@Action("policy/getPolicyList") private getPolicy: any;
	@Action("policy/getApplyList") private getApplyList: any;
	@Action("policy/getPublicyPolicy") private getPublicyPolicy: any;
	@Getter("provinceId") private provinceId: any;
	directCityList = this.$root.$data.directCityList;
	active = 0;
	btnList: Array<any> = [];
	tableData: any = [];
	loading = false;
	// tableData
	policyData: any = [];
	projectData: any = [];
	publicyData: any = [];
	newPublicyData: any = [];
	// loading
	loading_policy = false;
	loading_project = false;
	toolData = [
		{
			src: require("@images/icon/tool_service_0.png"),
			text: "高新技术企业认定诊断工具",
			path: "/pcm/verify",
			tag: "享政策补贴 税收减免"
		},
		{
			src: require("@images/icon/tool_service_1.png"),
			text: "研发费用加计扣除",
			path: "/pcm/productSale",
			tag: "一键评测 享税收优惠"
		},
		{
			src: require("@images/icon/tool_service_2.png"),
			text: "重点软件企业诊断工具",
			path: "/pcm/tax",
			tag: "精准诊断 享税率优惠"
		}
	];
	loading_publicy = false;
	created() {
		this.setPublicyTabData();
		this.getData();
	}
	async setPublicyTabData() {
		const {
			cityName,
			provinceName,
			centerName
		} = this.$root.$data.currentAreaProps;
		if (this.directCityList.includes(this.cityId)) {
			this.btnList = [cityName, centerName, "全部"];
		} else {
			this.btnList = [cityName, provinceName, "全部"];
		}
	}
	getData() {
		this.getPolicyList();
		this.getProjectList();
		this.getPublicyList();
		this.getNewPublicyList();
	}
	async getPolicyList(type = this.active) {
		this.loading_policy = true;
		const options: any = {
			current: 1,
			size: 8
		};
		const {
			centerId,
			provinceId,
			cityId,
			cityList
		} = this.$root.$data.currentAreaProps;
		let _cityList = [],
			allArea = [],
			_code = "";
		if (this.directCityList.includes(cityId)) {
			_cityList = cityList.concat([provinceId], [cityId]);
			allArea = _cityList.concat([centerId]);
			_code = centerId;
		} else {
			_cityList = cityList.concat([cityId]);
			allArea = _cityList.concat([centerId], [provinceId]);
			_code = provinceId;
		}
		switch (type) {
			case 1:
				{
					options.addressCode = _code;
					options.listType = 1;
				}
				break;
			case 2:
				{
					options.addressCodeList = allArea;
					options.listType = null
				}
				break;
			case 0:
				{
					options.addressCodeList = _cityList;
					options.listType = null
				}
				break;
			default:
				break;
		}
		return this.getPolicy(options)
			.then((res: any) => {
				const { code, data } = res;
				if (code === 0) {
					const { records } = data;
					this.policyData = records.map((policy: any) => {
						const { title, releaseDate: date, id } = policy;
						return {
							id,
							title,
							date
						};
					});
					return records;
				}
			})
			.catch((err: any) => err)
			.finally(() => {
				this.loading_policy = false;
			});
	}
	async getProjectList() {
		this.loading_project = true;
		const { cityId } = this.$root.$data.currentAreaProps;
		const options: any = {
			current: 1,
			size: 4,
			addressCode: cityId,
			listType: 0,
			sort: "热度"
		};
		this.getApplyList(options)
			.then((res: any) => {
				const { code, data, msg } = res;
				if (code === 0) {
					const { total, records } = data;
					this.projectData = records.map(
						({
							labels,
							department,
							gmtCreate,
							gmtEnd,
							dispatchDirection,
							supportAmount,
							...item
						}: any) => {
							const currentDate = new Date().getTime();
							const releasedDate: any = gmtCreate
								? new Date(gmtCreate).getTime()
								: null;
							const deadDate: any = gmtEnd ? new Date(gmtEnd).getTime() : null;
							const depart = department.departmentName || null;
							const title = `${item.title}(${dispatchDirection})`;
							const money = `${
								supportAmount ? (supportAmount / 10000).toFixed(0) : 0
							}万元`;
							delete item.title;
							let state = "";
							if (gmtCreate && currentDate) {
								if (currentDate > releasedDate) {
									state = "兑现中";
								} else {
									state = "未开始";
								}
								if (deadDate && currentDate > deadDate) {
									state = "已截止";
								}
							}
							const label =
								labels.indexOf(",") > 0
									? labels.split(",")
									: labels.split("，");
							return {
								title,
								depart,
								tags: [money, label.length > 0 ? label[0] : null, state],
								...item
							};
						}
					);
					return records;
				}
			})
			.catch((err: any) => err)
			.finally(() => (this.loading_project = false));
	}
	async getPublicyList() {
		this.loading_publicy = true;
		const { provinceId, cityId, cityList } = this.$root.$data.currentAreaProps;
		const allArea = cityList.concat([provinceId], [cityId]);
		const options: any = {
			current: 1,
			size: 5,
			addressCodeList: allArea,
			sort: "热度"
		};
		this.getPublicyPolicy(options)
			.then((res: any) => {
				const { code, data, msg } = res;
				if (code === 0) {
					const { records } = data;
					this.publicyData = records.map(
						({
							addressCode,
							content,
							releaseDate,
							department,
							id,
							title,
							deadline,
							pageView
						}: any) => {
							const release_date = new Date(releaseDate);
							const dead_date = new Date(deadline);
							const current_date = new Date();
							let stater = 0;
							if (current_date.getTime() < release_date.getTime()) {
								stater = 0;
								// not publish
							} else if (current_date.getTime() > dead_date.getTime()) {
								// deadline
								stater = 2;
							} else {
								stater = 1;
							}
							return {
								addressCode,
								content,
								releaseDate,
								department,
								id,
								title,
								stater,
								pageView: pageView + pageViewUnit
							};
						}
					);
					return records;
				}
			})
			.catch((err: any) => err)
			.finally(() => (this.loading_publicy = false));
	}
	async getNewPublicyList() {
		const { provinceId, cityId, cityList } = this.$root.$data.currentAreaProps;
		const allArea = cityList.concat([provinceId], [cityId]);
		const options: any = {
			current: 1,
			size: 2,
			addressCodeList: allArea,
			sort: null
		};
		this.getPublicyPolicy(options)
			.then((res: any) => {
				const { code, data, msg } = res;

				if (code === 0) {
					const { records } = data;
					this.newPublicyData = records.map(
						({
							addressCode,
							lead: htmlContent,
							releaseDate,
							department,
							id,
							title,
							deadline,
							pageView
						}: any) => {
							const release_date = new Date(releaseDate);
							const dead_date = new Date(deadline);
							const current_date = new Date();
							let stater = 0;
							if (current_date.getTime() < release_date.getTime()) {
								stater = 0;
								// not publish
							} else if (current_date.getTime() > dead_date.getTime()) {
								// deadline
								stater = 2;
							} else {
								stater = 1;
							}
							let content = "";
							if (htmlContent) {
								content = removeHTMLTag(htmlContent);
							}
							return {
								addressCode,
								content,
								releaseDate,
								department,
								id,
								title,
								stater,
								pageView: pageView + pageViewUnit
							};
						}
					);
					return records;
				}
			})
			.catch((err: any) => err);
	}
	clickPolicyLabel({ title, pubDate, id: policyId }: any) {
		this.$router.push({
			path: "/detail/policy",
			query: {
				policyId
			}
		});
	}
	clickPublicyLabel({ id: informId }: any) {
		this.$router.push({
			path: "/detail/inform",
			query: { informId }
		});
	}
	clickPolicyBtn(index: any) {
		this.active = index;
		switch (index) {
			case 0:
				this.getPolicyList(0);
				break;
			case 1:
				this.getPolicyList(1);
				break;
			case 2:
				this.getPolicyList(2);
				break;
			default:
				this.getPolicyList(0);
				break;
		}
	}
	clickPolicyMore() {
		this.$router.push({ path: "/pcm/policy" });
	}
	clickProjectLabel({ did: directionId, id: projectId }: any) {
		this.$router.push({
			path: "/detail/apply",
			query: {
				directionId,
				projectId
			}
		});
	}
	clickPublicyMore() {
		this.$router.push({
			path: "/pcm/inform"
		});
	}
	clickProjectMore() {
		this.$router.push({ path: "/pcm/apply" });
	}
	// update when cityid changed
	@Getter("cityId") private cityId: any;
	@Watch("cityId", { immediate: true })
	handleCityChange() {
		this.setPublicyTabData();
		this.getData();
	}
}
